import getWrappedUseMutation from "api/helpers/getWrappedUseMutation";
import apiClient from "api-client";

export const useCreateParticipationCodeMutation = getWrappedUseMutation(apiClient.ParticipationCodes.post);

export const useUpdateParticipationCodeMutation = getWrappedUseMutation(apiClient.ParticipationCodes.put);
